import React from 'react';
import { pathOr } from 'ramda';
import { Tabs } from 'antd';
import Translate from 'react-translate-component';

import ProjectGeneral from './fields/ProjectGeneral';
import ProjectParticipants from './fields/ProjectParticipants';
import WorkConditions from './fields/WorkConditions';
import RequirementsForCandidate from './fields/RequirementsForCandidate';
import ProjectApprovals from './fields/ProjectApprovals';
import ProjectComments from 'components/common/fields/CommentsField';
import ProjectResponsibilities from './fields/ProjectResponsibilities';
import ProjectPersonalQualities from './fields/ProjectPersonalQualities';
import ProjectClassifiers from './fields/ProjectClassifiers';
import { DocumentTabHeader } from 'components/common/fields/DocumentTabHeader';
import DocumentList from 'components/common/fields/DocumentList';
import { notEmpty } from 'utils/ramdaAdditions';

const getDocCount = pathOr(0, ['documents', 'length']);

export default function ProjectCard ({ project, meta }) {
    const docsCount = getDocCount(project);

    const GeneralTabHead = <Translate content="project.project_information" component="span" />;
    const DocumentTabHead = <DocumentTabHeader docsCount={ docsCount } />;

    return (
        <div>
            { notEmpty(project) &&
                <Tabs defaultActiveKey="general">
                    <Tabs.TabPane key="general" tab={GeneralTabHead}>
                        { meta.success && (
                            <div>
                                <ProjectGeneral project={project} />
                                <ProjectParticipants project={project} />
                                <RequirementsForCandidate project={project} />
                                <ProjectPersonalQualities project={project} />
                                <ProjectResponsibilities project={project} />
                                <WorkConditions project={project} />
                                <ProjectApprovals approvals={project.approval} />
                                <ProjectComments comments={project.comments} />
                                <ProjectClassifiers classifiers={project.classifiers} />
                            </div>
                        )}
                    </Tabs.TabPane>
                    <Tabs.TabPane key="documents" tab={DocumentTabHead}>
                        { meta.success && <DocumentList documents={ project.documents } /> }
                    </Tabs.TabPane>
                </Tabs>
            }
        </div>
    );
}
